import axios from "axios";
import { eventActionTypes } from "./eventTypes";
import baseUrl from "../../config/api";

export const getAllEventsStart = () => ({
  type: eventActionTypes.GET_ALL_EVENTS_START
});

export const getAllEventsSuccess = (events) => ({
  type: eventActionTypes.GET_ALL_EVENTS_SUCCESS,
  payload: events,
});

export const getAllEventsFailure = (error) => ({
  type: eventActionTypes.GET_ALL_EVENTS_FAILURE,
  payload: error,
});

export const getAllEvents = (userId,deviceId, token) => async (dispatch) => {
    dispatch(getAllEventsStart());
    try {
      const response = await axios.get(
        `${baseUrl}/trackAPI/events/${userId}/${deviceId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      dispatch(getAllEventsSuccess(response.data));
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Failed to fetch notifications.";
      dispatch(getAllEventsFailure(errorMsg));
    }
  };
